<div class="container">
  <div class="pt-3 d-none d-lg-block">
    <div class="rewards-detail-back-btn text-white cursor-pointer gloss-black" [routerLink]="'/rewards/raffles'">
      <span class="material-icons"> arrow_back_ios </span>
    </div>
  </div>
  <fgb-points-summary-bar [backButtonLink]="'/rewards/raffles'"></fgb-points-summary-bar>
</div>
<!--Lotto Details-->
<fgbcl-lotto-details [lottoId]="id" [showTermsAndConditions]="true"></fgbcl-lotto-details>
